import UpArrow from 'material-ui/svg-icons/navigation/arrow-drop-up';
import DownArrow from 'material-ui/svg-icons/navigation/arrow-drop-down';
import React from 'react';
import './PercentChangeIndicator.styl';
import theme from 'styles/theme';

export const PercentChangeIndicator = ({avg, useArrow = true}) => {
  if (avg == null) {
    return null;
  }

  return (
    <div className={`percent-change-indicator ${signClass(useArrow, avg)}`}>
      {useArrow && avg > 0 && <UpArrow className={'up-arrow'} color={theme.palette.topRank} />}
      {useArrow && avg < 0 && (
        <DownArrow className={'down-arrow'} color={theme.palette.bottomRank} />
      )}
      {avg === 0 && useArrow && <div className="placeholder" />}
      <span>{(!useArrow && avg > 0 ? '+' : '') + avg + '%'}</span>
    </div>
  );
};

function signClass(useArrow, avg) {
  if (useArrow) return '';
  if (avg > 0) return 'plus';
  if (avg < 0) return 'minus';
  return 'no-change';
}
